// export const API_URL = "https://99ea-103-198-173-186.ngrok.io";
// export const API_URL = "https://api.arkpass.com"
// export const API_URL = "https://59d7-43-251-93-20.ngrok.io";
export const API_URL = "https://backend.travelquail.com";
